export const hasWordOfLength = function(text, length) {
	let result = false;
	let splitText;

	if (text) {
		splitText = text.split(' ');

		for (let index = 0; index < splitText.length; index++) {
			if (splitText[index].length >= length) {
				result = true;
				break;
			}
		}
	}

	return result;
};
